import React from 'react';
import './BalanceWarning.css';

interface BalanceWarningProps {
  username: string;
  pointsShort: number;
  className?: string;
}

export const BalanceWarning: React.FC<BalanceWarningProps> = ({ username, pointsShort, className }) => (
  <div className={`balance-warning-pill${className ? ` ${className}` : ''}`}>
    <span className="balance-warning-text">
      {username} is {pointsShort.toLocaleString()} points short
    </span>
  </div>
);
